import { render } from "./PersonaliaForm.vue?vue&type=template&id=25680404"
import script from "./PersonaliaForm.vue?vue&type=script&lang=js"
export * from "./PersonaliaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__